export default __webpack_public_path__ + "static/media/ForgotPassword.901e333d.svg";